import axios from 'axios';
import CryptoJS from 'crypto-js';
import { domainUrl, dcode } from '../data/dummyData';

const instance = axios.create({
  baseURL: domainUrl,
});

const decryptPayload = (payload) => {
  if (!payload || typeof payload !== 'string') return payload;

  try {
    const raw = Uint8Array.from(atob(payload), c => c.charCodeAt(0));

    const iv = CryptoJS.lib.WordArray.create(raw.slice(0, 16));
    const encrypted = CryptoJS.lib.WordArray.create(raw.slice(16));

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encrypted },
      CryptoJS.enc.Utf8.parse(dcode),
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    const text = decrypted.toString(CryptoJS.enc.Utf8);

    if (!text) throw new Error('Empty decrypted result');

    return JSON.parse(text);
  } catch (e) {
    console.warn('⚠️ Decryption skipped/failed:', e.message);
    return payload;
  }
};

instance.interceptors.response.use(
  (response) => {
    const res = { ...response };

    // 🔥 Handle your actual API structure
    if (typeof res.data?.payload === 'string') {
      res.data = decryptPayload(res.data.payload);
    }

    return res;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default instance;